'use strict';

/**
 * Returns an array of all the values of an object, and retains the type of the values.
 *
 * @param x - The object from which to extract values.
 * @returns An array containing all the values of the object.
 */ function values(x) {
    return Object.values(x);
}

module.exports = values;
